import { render, staticRenderFns } from "./shoplogin.vue?vue&type=template&id=511213b6&scoped=true"
import script from "./shoplogin.vue?vue&type=script&lang=js"
export * from "./shoplogin.vue?vue&type=script&lang=js"
import style0 from "./shoplogin.vue?vue&type=style&index=0&id=511213b6&prod&lang=scss&scoped=true"
import style1 from "./shoplogin.vue?vue&type=style&index=1&id=511213b6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "511213b6",
  null
  
)

export default component.exports